<template>
    <div>
      <ValidationObserver ref="observer" v-slot="{ slot: passes }" v-if="!loading">
        <v-row no-gutters align="center" justify="center">
          <v-col :cols="!$vuetify.breakpoint.xs ?'16' :'10'">
            <validation-provider name="area" mode="eager" rules="required" v-slot="{ errors }">
              <autocomplete-cadu
                :errorMessage="errors[0]"
                title="Tipo de Área"
                placeholder="Selecione o Tipo de Área"
                :items="areas.map((el) => el.nome)"
                v-model="areaValor"
                @index="(index) => areaIndex = index"
                @input="value => areaValor = value"
                class="pt-3 pb-1"
                :colorText="$vuetify.theme.themes.light.fontColor1"
              />
            </validation-provider>
          </v-col>
        </v-row>
        <v-row no-gutters align="center" justify="center">
          <v-col :cols="!$vuetify.breakpoint.xs ?'16' :'10'">
            <validation-provider name="cargo" mode="eager" rules="required" v-slot="{ errors }">
              <autocomplete-cadu
                :errorMessage="errors[0]"
                title="Tipo de Cargo"
                placeholder="Selecione o Tipo de Cargo"
                :items="cargos.map((el) => el.nome)"
                v-model="cargoValor"
                @index="(index) => cargoIndex = index"
                @input="value => cargoValor = value"
                class="py-1"
                :colorText="$vuetify.theme.themes.light.fontColor1"
              />
            </validation-provider>
          </v-col>
        </v-row>
        <v-row no-gutters align="center" justify="center">
          <v-col :cols="!$vuetify.breakpoint.xs ?'16' :'10'">
            <validation-provider name="tel" mode="eager" rules="required|telRequired" v-slot:default="{ errors }">
              <input-cadu
                :errorMessage="errors[0]"
                title="Telefone Corporativo"
                placeholder="Insira seu telefone"
                v-model="telefone"
                onlyNumber
                typeInput="tel"
                v-mask="telMask"
                class="py-1"
                :colorText="$vuetify.theme.themes.light.fontColor1"
                @input="telMuda"
              />
            </validation-provider>
          </v-col>
        </v-row>
        <v-row no-gutters align="center" justify="center">
          <v-col :cols="!$vuetify.breakpoint.xs ?'16' :'10'">
            <validation-provider name="email" mode="eager" rules="required|email" v-slot:default="{ errors }">
              <input-cadu
                :errorMessage="errors[0]"
                title="E-mail corporativo"
                placeholder="Insira seu e-mail"
                v-model="email"
                class="pb-2"
                :colorText="$vuetify.theme.themes.light.fontColor1"
                :onlylowerCase="true"
              />
            </validation-provider>
          </v-col>
        </v-row>
      </ValidationObserver>
      <component-loading :value="loading"/>
    </div>
</template>

<script>
import { mask } from 'vue-the-mask'
import { ValidationProvider, ValidationObserver } from 'vee-validate'
import Usuario from '@/services/Usuario'
import Area from '@/services/Area'
import Cargo from '@/services/Cargo'

export default {
  name: 'FormModal',
  components: {
    ValidationProvider,
    ValidationObserver
  },
  directives: {
    mask
  },
  data () {
    return {
      areas: [],
      value: '',
      cargos: [],
      area: '',
      cargo: '',
      telefone: '',
      email: '',
      areaIndex: Number,
      cargoIndex: Number,
      areaTempIndex: -1,
      cargoTempIndex: -1,
      telMask: '(##) #####-####',
      areaValor: '',
      cargoValor: '',
      idUnimed: -1,
      tokenBearer: '',
      loading: false
    }
  },
  beforeMount () {
    this.meusDados()
  },
  methods: {
    telMuda () {
      if (this.telefone.length > 14) {
        this.telMask = '(##) #####-####'
      } else if (this.telefone.length <= 14) {
        this.telMask = '(##) ####-#####'
      }
    },
    async validate () {
      const valorArea = this.areas.find(area => area.nome === this.areaValor)
      const valorCargo = this.cargos.find(cargo => cargo.nome === this.cargoValor)

      let responseValidate = await this.$refs.observer.validate()

      if (responseValidate === true) {
        let data = {
          emailCorporativo: this.email,
          telefoneCorporativo: this.telefone,
          tipoArea: {
            id: valorArea.id
          },
          cargo: {
            id: valorCargo.id
          }
        }

        return data
      }
      return false
    },
    async verifyArea () {
      let that = this
      this.areas.forEach((el, index) => {
        if (el.id === that.areaTemp.id) {
          that.areaTempIndex = index
          that.areaValor = el.nome
        }
      })
    },
    async verifyCargo () {
      let that = this
      this.cargos.forEach((el, index) => {
        if (el.id === that.cargoTemp.id) {
          that.cargoTempIndex = index
          that.cargoValor = el.nome
        }
      })
    },
    async meusDados () {
      this.tokenBearer = localStorage.getItem('tokenBearer')
      this.loading = true
      let usuario = new Usuario(this.tokenBearer, this.$appConfig.config.API)
      let area = new Area(this.tokenBearer, this.$appConfig.config.API)
      let cargo = new Cargo(this.tokenBearer, this.$appConfig.config.API)

      try {
        let responseUsuario = await usuario.getUser()
        responseUsuario = responseUsuario.data
        this.idUnimed = responseUsuario.unimed.id

        let responseArea = await area.getAreas()
        let responseCargo = await cargo.getCargos()
        responseArea = responseArea.data
        responseCargo = responseCargo.data

        this.verifyPendencia({ responseUsuario, responseArea, responseCargo })
      } catch (err) {
        console.error(err)
      }
    },
    async verifyPendencia (data) {
      let responseUsuario = data.responseUsuario
      let responseArea = data.responseArea
      let responseCargo = data.responseCargo

      // listagem
      this.areas = responseArea
      this.cargos = responseCargo

      // valores individuais
      this.email = responseUsuario.emailCorporativo ? responseUsuario.emailCorporativo : ''
      this.telefone = responseUsuario.telefoneCorporativo ? responseUsuario.telefoneCorporativo : ''
      this.areaTemp = responseUsuario.tipoArea ? responseUsuario.tipoArea : ''
      this.cargoTemp = responseUsuario.cargo ? responseUsuario.cargo : ''

      this.verifyArea()
      this.verifyCargo()
      this.loading = false
    }
  },
  watch: {
    email () {
      requestAnimationFrame(() => {
        this.$refs.observer.reset()
      })
      this.email = this.email.toLowerCase()
    },
    telefone () {
      requestAnimationFrame(() => {
        this.$refs.observer.reset()
      })
      this.telefone = this.telefone
    }

  }
}
</script>
